import {
  createDeleteIDBValueByKey,
  createGetAllIDBValues,
  createGetIDBValueByKey,
  createSetIDBValue,
  openDB,
} from './indexedDB.utils';
import { OFFLINE_DB } from '../constants/indexedDB.constants';

const {
  NAME,
  VERSION,
  OBJECT_STORES: { ENTITIES, REQUESTS, SEARCH_RESULTS },
  KEY_PATHS: { ID },
} = OFFLINE_DB;

export const offlineDB = openDB(NAME, VERSION, {
  upgrade(db) {
    db.createObjectStore(ENTITIES, {
      keyPath: ID,
    });
    db.createObjectStore(REQUESTS, {
      keyPath: ID,
    });
    db.createObjectStore(SEARCH_RESULTS, {
      keyPath: ID,
    });
  },
});

export const setOfflineDBValue = createSetIDBValue(offlineDB);

export const deleteOfflineDBValueByKey = createDeleteIDBValueByKey(offlineDB);

export const getOfflineDBValueByKey = createGetIDBValueByKey(offlineDB);

export const getAllOfflineDBValues = createGetAllIDBValues(offlineDB);
